// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d05c29db","821":"382657e6"}[chunkId] + ".chunk.js";
};